import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  SWAPS_NEW,
  SWAPS_DETAIL,
} from '../../helpers/routes';

import New from './New';
import Landing from './Landing';
import SwapsDetail from './SwapsDetail';
import TrackingRoute from '../TrackingRoute';
import PermsError from '../Errors/PermsError';

import { getSwaps } from '../../actions/swaps';
import { getSwapEligibility } from '../../actions/swapEligibility';
import { getAccount } from '../../actions/account';
import LoadingWrapper from '../../components/LoadingWrapper';

class Swaps extends Component {
  async componentDidMount() {
    const {
      handleGetSwaps,
      handleGetSwapEligibility,
      handleGetAccount,
    } = this.props;

    await handleGetAccount();

    const {
      canViewSwaps,
    } = this.props;

    if (!canViewSwaps) {
      return;
    }

    handleGetSwaps();
    handleGetSwapEligibility();
  }

  render() {
    const {
      accountLoading,
      swapsLoading,
      canViewSwaps,
      orders,
    } = this.props;

    if (!accountLoading && !canViewSwaps) {
      return <PermsError />;
    }

    if (accountLoading || swapsLoading) {
      return <LoadingWrapper />;
    }

    return (
      <Switch>
        <Route path={SWAPS_NEW} component={New} />
        <TrackingRoute
          exact
          path={SWAPS_DETAIL}
          component={SwapsDetail}
        />
        <Route
          render={matchProps => (
            <Landing orders={orders} {...matchProps} />
          )}
        />
      </Switch>
    );
  }
}

const mapStateToProps = ({
  swaps: { data: { orders = [] } = {}, loading: swapsLoading },
  auth: {
    accountPerms,
  },
  account: { data: accountData = {}, loading: accountLoading },
}) => {
  const hasSwapPerms = accountPerms.some(role => role === 'PRIMARY' || role === 'BILLPAY');
  const hasActiveAccount = accountData.status === 'ACTIVE';
  const isPrepaid = accountData.prepaid;

  return {
    orders,
    swapsLoading,
    accountLoading,
    canViewSwaps: hasSwapPerms && hasActiveAccount && !isPrepaid,
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  handleGetSwaps: getSwaps,
  handleGetSwapEligibility: getSwapEligibility,
  handleGetAccount: getAccount,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Swaps);
